import { chevronRightIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const ChevronRight = createIcon({
  displayName: 'ChevronRight',
  paths: [
    'M384.004 810.688c-10.453 0-20.949-3.797-29.184-11.563-17.195-16.085-18.048-43.093-1.92-60.288l226.731-241.877-224.725-209.748c-17.237-16.085-18.176-43.051-2.091-60.288 16.085-17.28 43.136-18.176 60.288-2.091l256 238.932c8.277 7.723 13.184 18.432 13.568 29.739 0.341 11.349-3.797 22.357-11.563 30.635l-256 273.067c-8.363 8.96-19.712 13.483-31.104 13.483z'
  ],
  canvasPaths: canvasIconPaths(chevronRightIcon)
})
